import { schema } from './dictionaryConnector'
import { CallApi } from '@signavio/kraken'

export { collection, schema } from './dictionaryConnector'

export const create =
  (callApi: CallApi, apiBase: string) =>
  (_: unknown, { connectorId }: { connectorId: string }) =>
    callApi(
      `${apiBase}/dictionary/connectors/${connectorId}/actions/reload`,
      schema,
      {
        method: 'POST',
      }
    )
